// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"2176031a","598":"79ff8420","703":"087aae89","787":"21f0e217","888":"07aef6fc"}[chunkId] + ".chunk.js";
};